<template>
    <div class="timeline-container" :style="{height: height}">
        <v-container class="top-part" :style="{height: topPartHeight}">
            <timeline
                :items="items"
                class="scrollbar-custom"
                style="height: 50vh; overflow-y: auto;"
                @selected-item="onSelectModelisation"
                :selectedItem="selectedModelisation || defaultSelectedItem"
            ></timeline>
        </v-container>
        <v-container class="bottom-part" :style="{height: bottomPartHeight}">
            <v-divider></v-divider>
            <div>
                <!-- en attente de voir si on réactive l'édition du datamodel en mode text editor -->
                <!-- <v-alert
                    :value="schema.hasUnsavedChange"
                    type="info"
                >
                    You have unsaved changes.
                </v-alert>
                <v-alert
                    :value="schema.schemaHasError"
                    class="modelisation-error"
                    type="error"
                    @click="showErrorsDetail = !showErrorsDetail"
                >
                    {{ schemaErrorCount }} error{{ schemaErrorCount > 1 ? 's' : '' }} found
                    <v-icon v-if="showErrorsDetail">keyboard_arrow_down</v-icon>
                    <v-icon v-else>keyboard_arrow_right</v-icon>
                </v-alert>
                <v-alert
                    v-if="showErrorsDetail"
                    :value="true"
                    style="width: 184px; margin-top: 0;"
                    color="error"
                >
                    <p v-for="(error, index) in schema.modelsStructureError" :key="index">
                        Line {{error.row + 1}}: {{error.text}}
                    </p>
                </v-alert> -->
                <v-alert
                    v-if="$store.getters.modelsHasErrors"
                    color="error"
                >
                    {{$t('instance.data_model.timeline_container.alert_disabled')}}
                </v-alert>
            </div>
            <v-btn
                v-if="$store.getters.freeVersion"
                small
                color="blue"
                @click="createNewVersion"
                style="font-size: 14px; width: 160px;height: 50px; padding-right: 10px; text-transform: initial; border-radius: 3px font-size: 14px;"
            >
                {{$t('instance.data_model.timeline_container.create_instance_free_version')}}
                <v-icon dark style="padding-left: 5px">add_box</v-icon>
            </v-btn>
        </v-container>

        <dialog-confirm
            ref="dialog-confirm"
            :text="$t('instance.data_model.timeline_container.dialog_confirm_text')"
            :title="$t('instance.data_model.timeline_container.dialog_confirm_title')"
            :text-confirm="$t('instance.data_model.timeline_container.dialog_confirm_text_confirm')"
            :text-decline="$t('instance.data_model.timeline_container.dialog_confirm_text_decline')"
        >
        </dialog-confirm>
    </div>
</template>

<script>

import DialogConfirm from '@/components/Partials/dialog-confirm.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import Timeline from '@/components/Partials/timeline.vue';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import {
    mapGetters
} from 'vuex';
export default {

    components: {
        Timeline,
        NsLoader,
        DialogConfirm,
    },

    props: {
        modelisations: {
            type: Array,
            required: true,
        },
        schema: {
            type: Object,
            required: true,
        },
        height: {
            type: Number,
            default: 500
        },
        saveDisabled: {
            type: Boolean,
            required: true
        },
        selectedModelisation:{
            type: Object,
        }
    },

    data (){
        return {
            showErrorsDetail: false,

        };
    },

    computed: {
        ...mapGetters([
            'getCurrentApplication'
        ]),
        items (){
            let cloneModelisation = cloneDeep(this.modelisations);
            return cloneModelisation.sort((a,b) => new Date(b.creation_date)-new Date(a.creation_date))
                .map((model) => {
                    return {
                        title: `v${model.version}`,
                        text: moment(model.creation_date).format('YYYY/MM/DD'),
                        uid: model.uid,
                        readOnly: !model.editable,
                    };
                });
        },

        topPartHeight (){
            return this.showErrorsDetail ?  this.schemaErrorCount > 2 ? '20%' : '70%' : '70%';
        },
        bottomPartHeight (){
            return this.showErrorsDetail ? this.schemaErrorCount > 2 ? '80%' : '30%' :'30%';
        },

        futureVersion (){
            return this.lastModelisationVersion + 1;
        },

        lastModelisationVersion (){
            return this.modelisations.map((model) => model.version).sort().reverse()[0];
        },

        schemaErrorCount (){
            try{
                return this.schema.modelsStructureError.length;
            }catch(e){
                return 0;
            }
        },
    },

    watch: {
        'schema.schemaHasError' (val){
            if(!val) this.showErrorsDetail = false;
        },

        modelisations (val){
            let lastModelisation = null;
            for (let item of val){
                if(lastModelisation === null){
                    lastModelisation = item;
                }else{
                    if(lastModelisation.version < item.version){
                        lastModelisation = item;
                    }
                }
            }
            if(lastModelisation.uid === this.selectedModelisation.uid) return;
            this.switchModelisation(lastModelisation);

        },
    },

    mounted (){
        this.switchModelisation(this.selectedModelisation);
    },

    methods: {
        createNewVersion(){
            let lastModelisationValue = this.modelisations[0].value;
            let cloneModelisation = cloneDeep(lastModelisationValue);
            this.$confirm(
                this.$t('instance.data_model.timeline_container.dialog_create_instance_confirm_text', {concreteSite: this.$store.getters.concreteSite}),
                this.$t('instance.data_model.timeline_container.dialog_create_instance_title'),
                {
                    confirmButtonText: this.$t('instance.data_model.timeline_container.dialog_create_instance_text_confirm'),
                    cancelButtonText: this.$t('instance.data_model.timeline_container.dialog_create_instance_text_decline'),
                    dangerouslyUseHTMLString: true,
                }
            ).then(() =>{
                this.$store.dispatch('patchItem', {
                    item:{
                        url: this.modelisations[0].url,
                        modelisation_uid: this.modelisations[0].uid,
                        editable: false,
                    },
                    url: this.$store.state.api.meta.listModels.modelisations.url,
                    model: 'modelisations',
                    scopes: this.$store.state.api.scopes || {},
                }).then(() => {
                }).catch((error) => {
                    console.error(error);
                }).then(() => {
                    this.$store.dispatch('createItem', {
                        item:{
                            application_uid: this.getCurrentApplication.uid,
                            editable: true,
                            version: this.futureVersion,
                            label: `v${this.futureVersion}`,
                            value: cloneModelisation,
                        },
                        url: this.$store.state.api.meta.listModels.modelisations.url,
                        model: 'modelisations',
                        scopes: this.$store.state.api.scopes || {},
                    }).then(()=> {
                    }).catch((error) => {
                        this.displayErrorSnackbar();
                        console.error(error);
                    });
                });
            });
        },
        onSelectModelisation (modelisation){
            this.$emit('save-previous-model');
            if(this.schema.hasUnsavedChange() && this.selectedModelisation.editable){
                this.$refs['dialog-confirm'].open().then((confirmed) => {
                    if(confirmed){
                        this.switchModelisation(modelisation);
                    }
                });
            }else{
                this.switchModelisation(modelisation);
            }
        },
        switchModelisation (modelisation){
            let relatedModelisation = this.modelisations.find((_modelisation) => _modelisation.uid === modelisation.uid);
            this.$emit('switch-modelisation', relatedModelisation);
        },
    },
};
</script>

<style lang="scss">
.timeline-container{
    .top-part{
        transition: all .6s;
    }
    .bottom-part{
        transition: all .6s;
        padding-top: 0;
        overflow-y: auto;
        overflow-x: hidden;
        .modelisation-error{
            cursor: pointer;
            width: 184px;
            margin-bottom: 0;
            div{
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
        }
        .expand-error{

        }
    }
    .no-modelisation-selected{
        padding: 5px;
        border: 2px solid #fff;
        animation-name: blink;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
    }

    @keyframes blink {
        from {border-color: rgba(255,255,255,1);}
        to {border-color: rgba(255,255,255,0);}
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/timeline-container.vue